/**
 * Sticky Header Component
 * Measures distance of header-container from viewport top.
 * When header-container reaches the top, makes it sticky with white background.
 */

export default function initStickyHeader() {
  const header = document.querySelector(".site-header-sticky");
  const headerContainer = document.querySelector(".header-container");

  if (!header || !headerContainer) {
    return;
  }

  let isSticky = false;

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Get the header-container's position relative to the viewport
    const headerContainerRect = headerContainer.getBoundingClientRect();
    const headerContainerTop = headerContainerRect.top;

    // Check if header-container has reached the top of the viewport
    if (headerContainerTop <= 0 && !isSticky) {
      header.classList.add("header-sticky");
      isSticky = true;
    } else if (headerContainerTop > 0 && isSticky) {
      header.classList.remove("header-sticky");
      isSticky = false;
    }
  }

  // Add scroll event listener with throttling for better performance
  let ticking = false;

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(handleScroll);
      ticking = true;
    }
  }

  function onScroll() {
    ticking = false;
    requestTick();
  }

  // Recalculate on resize
  function onResize() {
    handleScroll();
  }

  // Initialize
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize, { passive: true });

  // Check initial state
  handleScroll();

  // Return cleanup function
  return function cleanup() {
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("resize", onResize);
  };
}
